// removed by extract-text-webpack-plugin
module.exports = {"purchaseInbox":"purchaseInbox__purchaseInbox___2EseB","purchaseInboxIconWrap":"purchaseInbox__purchaseInboxIconWrap___26LC9","purchaseInboxIcon":"purchaseInbox__purchaseInboxIcon___3_8jt","purchaseInboxItems":"purchaseInbox__purchaseInboxItems___3sOm-","purchaseInboxItem":"purchaseInbox__purchaseInboxItem___3bpt6"};


//////////////////
// WEBPACK FOOTER
// ./src/purchases/purchaseInbox.scss
// module id = 1260
// module chunks = 0